import { render, staticRenderFns } from "./AgList.vue?vue&type=template&id=4b5de4f0&scoped=true"
import script from "./AgList.vue?vue&type=script&lang=js"
export * from "./AgList.vue?vue&type=script&lang=js"
import style0 from "./AgList.vue?vue&type=style&index=0&id=4b5de4f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5de4f0",
  null
  
)

export default component.exports